import React, { useMemo } from 'react';
import { Article } from '../../types';
import ArticleVideo from './ArticleVideo';

interface ArticleBodyProps {
  article: Article;
}

/**
 * جای بلوک ویدیو در متن: نشانگر <!--video--> یا [[video]] در محتوا؛
 * وگرنه پیش از سومین سرفصل (بعد از دو بخش اول)؛ اگر سرفصل کم بود، انتهای متن.
 */
export const splitContentForVideo = (html: string): [string, string | null] => {
  // نشانگر ممکن است داخل یک پاراگراف تنها باشد؛ تگ‌های p اطرافش هم حذف می‌شوند
  const marker = /(?:<p[^>]*>\s*)?(?:<!--\s*video\s*-->|\[\[\s*video\s*\]\])(?:\s*<\/p>)?/i;
  const markerMatch = marker.exec(html);
  if (markerMatch) {
    return [html.slice(0, markerMatch.index), html.slice(markerMatch.index + markerMatch[0].length)];
  }
  const positions: number[] = [];
  const re = /<h2\b/gi;
  let m: RegExpExecArray | null;
  while ((m = re.exec(html))) positions.push(m.index);
  if (positions.length >= 3) return [html.slice(0, positions[2]), html.slice(positions[2])];
  return [html, null];
};

/** متن مقاله با استایل blog-prose و ویدیوی میان‌متن */
const ArticleBody: React.FC<ArticleBodyProps> = ({ article }) => {
  const [before, after] = useMemo(() => splitContentForVideo(article.content || ''), [article.content]);
  const hasVideo = !!article.videoUrl;

  return (
    // فاصلهٔ قبل از ویدیو طبق طرح (موبایل ۴۸، دسکتاپ ۱۶)؛ بعد از آن فاصلهٔ خود سرفصل بعدی
    <div className="flex flex-col">
      <div className="blog-prose" dangerouslySetInnerHTML={{ __html: before }} />
      {hasVideo && (
        <div className="pt-12 lg:pt-4">
          <ArticleVideo article={article} />
        </div>
      )}
      {after && <div className="blog-prose" dangerouslySetInnerHTML={{ __html: after }} />}
    </div>
  );
};

export default ArticleBody;
